import { Box, Button, CircularProgress, Typography } from '@mui/material'

export const Loader = () => {
    return (
        <Box
            sx={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0 }}
            display="flex"
            flexGrow={1}
            justifyContent="center"
            alignItems="center"
        >
            <CircularProgress sx={{ alignSelf: 'center', justifySelf: 'center' }} />
        </Box>
    )
}

// Shown instead of the Loader when the summary request failed, so the tabs don't spin forever
export const LoadError = ({ onRetry }: { onRetry: () => void }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            flexGrow={1}
            gap={2}
            justifyContent="center"
            alignItems="center"
            py={4}
        >
            <Typography textAlign="center">Couldn't load missions right now.</Typography>
            <Button variant="contained" onClick={onRetry}>
                Retry
            </Button>
        </Box>
    )
}

// All references should use missions terminology
